import { defineStyle } from "@chakra-ui/react";

export const TaskCardStyles = () => {
  return {
    mainContainer: defineStyle({
      width: ["480px", "480px", "480px", "480px", "400px", "480px"],
      borderRadius: "lg",
      boxShadow: "md",
      p: 2,
      bg: "white",
      _hover: {
        cursor: "pointer",
        backgroundColor: "#FFF2F0",
      },
      "@media screen and (min-width: 1280px) and (max-width: 1380px)": {
        width: "370px",
      },
      "@media screen and (min-width: 1380px) and (max-width: 1430px)": {
        width: "410px",
      },
      "@media screen and (min-width: 1430px) and (max-width: 1536px)": {
        width: "430px",
      },
    }),
    topContainer: defineStyle({
      align: "stretch",
      width: "100%",
      h: "72%",
      alignItems: "flex-start",
    }),
    subjectIcon: defineStyle({
      width: "76px",
      height: "76px",
      "@media screen and (min-width: 1280px) and (max-width: 1360px)": {
        width: "60px",
        height: "60px",
      },
      display: "flex",
      alignItems: "flex-start",
    }),
    detailsContainer: defineStyle({
      width: "100%",
      alignItems: "start",
    }),
    topLine: defineStyle({
      width: "100%",
    }),
    taskTypeText: defineStyle({
      fontSize: "12px",
      fontWeight: 400,
      bg: "#FEFAE6",
      borderRadius: "14px",
      padding: "6px 4px",
      lineHeight: "14px",
      fontFamily: "Poppins",
      "@media screen and (min-width: 1280px) and (max-width: 1360px)": {
        padding: "6px 2px",
      },
    }),
    completionContainer: defineStyle({
      spacing: 2,
    }),
    completionText: defineStyle({
      fontSize: "12px",
      color: "purple.800",
      "@media screen and (min-width: 1280px) and (max-width: 1380px)": {
        fontSize: "10px",
      },
    }),
    overDueDate: defineStyle({
      fontSize: "10px",
      fontWeight: "semibold",
      color: "red",
    }),
    inTimeDate: defineStyle({
      fontSize: "10px",
      fontWeight: "semibold",
      color: "purple.800",
    }),
    tickMarkIcon: defineStyle({
      width: "24px",
      height: "24px",
    }),
    taskTitle: defineStyle({
      height: "48px",
      noOfLines: 2,
      fontSize: "16px",
      fontFamily: "Poppins",
      fontWeight: "bold",
      mb: 4,
      color: "purple.800",
    }),
    bottomContainer: defineStyle({
      borderTopWidth: 1,
      borderTopColor: "#00000033",
      padding: 2,
      mb: 2,
    }),
  };
};
